module.exports = __webpack_public_path__ + "img/tz4.b71e5e69.jpg";